export const Email = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";
export const NameIdentifier = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
export const Role = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
export const FirstName = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";
export const LastName = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname";

interface IClaims {
    [Email] : string;
    [NameIdentifier] : string;
    [FirstName] : string;
    [LastName] : string;
    [Role] : string;
}
export default interface IJwtToken {
    issuer: string;
    audience: string;
    expires: string;
    signingCredentials: string;
    claims: IClaims;
}